module.exports = __webpack_public_path__ + "img/b53437b3a611b786e212816a92dd93ff.png";